import graphicsSrc from "@/assets/connect-to-scm-showcase-graphics.svg";

export function ConnectToScmShowcase() {
    return (
        <div className="m-auto flex flex-col space-y-2 p-8">
            <div className="mb-8 flex flex-col items-center justify-center space-y-2">
                <img
                    src={graphicsSrc}
                    alt="Graphics for keeping momentum on any device"
                    className="h-[400px] select-none"
                />
            </div>
            <p className="mb-2 text-center text-2xl text-[rgb(var(--ona-gray-100))]">Keep momentum on any device</p>
            <p className="text-center text-[rgb(var(--ona-gray-100))]">
                Transition seamlessly between Ona&#x2019;s conversational interface, native VS Code in the browser or
                any desktop IDE.
            </p>
        </div>
    );
}
